import Rule from '../Rule'

export default class Regex extends Rule {

  passes (regex) {
    return regex.test(this.value)
  }
}
